var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-cardsmalllocation"},[_c('img',{staticClass:"img-cardsmalllocation",attrs:{"src":_vm.item.photo,"alt":"Photo"}}),_c('h4',{staticClass:"label-cardscmalllocation"},[_vm._v(" "+_vm._s(_vm.getTitle())+" ")]),_c('div',{staticClass:"div-background-cardsmalllocation"})])
}
var staticRenderFns = []

export { render, staticRenderFns }